import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getTaskSummary = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/monitoring-host/tasks/monthly-summaries` });

  return data;
};

export default getTaskSummary;
